export const LOW_ENCODER_CONFIG = {
  width: 240,
  height: 180,
  framerate: 15,
  bitrate: 120,
};

export enum ClientRole {
  Host = 'host',
  Audience = 'audience',
}
